export enum ImageFormat {
  JPEG = 'jpeg',
  PNG = 'png',
}

